// Store de permisos del usuario actual
import { usersApi } from '../services/api';

export interface Permissions {
  role: string;
  modules: string[];
  showPhones: boolean;
  canCreateOrders: boolean;
  canManageUsers: boolean;
  showAgentesIA: boolean;
  canAddColaTpu?: boolean;
}

let cached: Permissions | null = null;

export async function loadPermissions(): Promise<Permissions> {
  try {
    const data = await usersApi.getPermissions();
    cached = data;
    return data;
  } catch {
    // Default: frontdesk (restrictivo)
    return { role: 'frontdesk', modules: [], showPhones: false, canCreateOrders: false, canManageUsers: false, showAgentesIA: false };
  }
}

export function getPermissions(): Permissions | null { return cached; }

export function hasModule(mod: string): boolean {
  if (!cached) return false;
  // master y admin tienen acceso a todo lo que empiece con el prefijo
  if (cached.modules.includes(mod)) return true;
  // Check si tiene acceso al módulo padre (ej: 'trabajos' para 'trabajos:cola')
  const parent = mod.split(':')[0];
  return cached.modules.includes(parent);
}

export function maskPhone(tel: string): string {
  if (!cached || cached.showPhones) return tel;
  if (tel.length <= 4) return '****';
  return tel.substring(0, 2) + '****' + tel.substring(tel.length - 2);
}
